import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/material";
import StarIconFilled from "../../../../../../assets/icons/StarIconFilled";
import StarIconOpen from "../../../../../../assets/icons/StarIconOpen";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";
import { CarrierService } from "../../../../../../services/CarrierService";
import { AlertContext } from "../../../../../Dashboard/Dashboard";

export default function UpdatePrimaryCarrierContactAction({ contact, contactUpdated }) {
  const { instance } = useMsal();
  const [isPrimary, setIsPrimary] = useState(false);
  const { warning } = useContext(AlertContext);

  const handleUpdate = () => {
    setIsPrimary(!isPrimary);
    let updatedContact = { ...contact };
    updatedContact.isPrimary = !isPrimary;

    CarrierService.UpdateCarrierContact(instance, updatedContact).then(res => {
      res.isUpdate = true;
      contactUpdated(res);
    }).catch(error => {
      console.error(error);
      warning(error);
    });
  };

  useEffect(() => {
    setIsPrimary(contact.isPrimary);
  }, [contact]);

  return (
    <StyledTooltip title="Primary">
      <Box>
        <InlineIconButton
          onClick={() => handleUpdate()}
          icon={isPrimary ? StarIconFilled : StarIconOpen}
          buttonColor="blue"
        />
      </Box>
    </StyledTooltip>
  );
}

UpdatePrimaryCarrierContactAction.propTypes = {
  contact: PropTypes.object.isRequired,
  contactUpdated: PropTypes.func.isRequired
};